import React from 'react';
import { MessageSquare, FileText, CheckCircle, Clock, User } from 'lucide-react';

const activities = [
  {
    id: '1',
    type: 'comment',
    title: 'New Comment Added',
    description: 'Sarah commented on the technical proposal',
    time: '10 minutes ago',
    user: {
      name: 'Sarah Johnson',
      avatar: 'https://ui-avatars.com/api/?name=Sarah+Johnson',
    },
  },
  {
    id: '2',
    type: 'document',
    title: 'Document Updated',
    description: 'Technical specifications updated',
    time: '1 hour ago',
    user: {
      name: 'Michael Chen',
      avatar: 'https://ui-avatars.com/api/?name=Michael+Chen',
    },
  },
  {
    id: '3',
    type: 'task',
    title: 'Task Completed',
    description: 'Security assessment documentation completed',
    time: '2 hours ago',
    user: {
      name: 'Emily Rodriguez',
      avatar: 'https://ui-avatars.com/api/?name=Emily+Rodriguez',
    },
  },
];

export function RecentActivities() {
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'comment':
        return <MessageSquare className="h-5 w-5 text-blue-500" />;
      case 'document':
        return <FileText className="h-5 w-5 text-purple-500" />;
      case 'task':
        return <CheckCircle className="h-5 w-5 text-green-500" />;
      default:
        return <Clock className="h-5 w-5 text-gray-500" />;
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium text-gray-900">Recent Activities</h2>
        <button className="text-sm font-medium text-purple-600 hover:text-purple-500">
          View all
        </button>
      </div>

      <div className="mt-6 flow-root">
        <ul className="-mb-8">
          {activities.map((activity, activityIdx) => (
            <li key={activity.id}>
              <div className="relative pb-8">
                {activityIdx !== activities.length - 1 ? (
                  <span
                    className="absolute left-5 top-5 -ml-px h-full w-0.5 bg-gray-200"
                    aria-hidden="true"
                  />
                ) : null}
                <div className="relative flex items-start space-x-3">
                  <div className="relative">
                    <img
                      className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white"
                      src={activity.user.avatar}
                      alt={activity.user.name}
                    />
                    <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-white ring-2 ring-white">
                      {getActivityIcon(activity.type)}
                    </span>
                  </div>
                  <div className="min-w-0 flex-1">
                    <div>
                      <div className="text-sm">
                        <a href="#" className="font-medium text-gray-900">
                          {activity.user.name}
                        </a>
                      </div>
                      <p className="mt-0.5 text-sm text-gray-500">{activity.time}</p>
                    </div>
                    <div className="mt-2">
                      <div className="text-sm font-medium text-gray-900">{activity.title}</div>
                      <p className="text-sm text-gray-500">{activity.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}